import { Component, Input, OnInit } from '@angular/core';

import { DocumentTemplateService } from '../../../../../../../services/document-template/document-template.service';
import {
  DocumentTemplateLinkedEventType
} from '../../../../../../../models/document-template';

@Component({
  selector: 'app-document-template-edit-linked-products',
  templateUrl: './document-template-edit-linked-products.component.html'
})
export class DocumentTemplateEditLinkedProductsComponent implements OnInit {

  @Input()
  documentTemplateId: number;

  public linkedEventTypes: DocumentTemplateLinkedEventType[] = [];

  public loading = false;
  public serverError: number = null;

  constructor(
    private documentTemplateService: DocumentTemplateService
  ) {}

  ngOnInit() {
    this.loadLinkedProducts();
  }

  public loadLinkedProducts() {
    this.loading = true;
    this.serverError = null;

    this.documentTemplateService
      .getLinkedProducts(this.documentTemplateId)
      .then(response => {
        this.linkedEventTypes = response.event_types;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loading = false; });
  }

}
